export default "__VITE_ASSET__CmybfNAf__"